import Header from '../components/Header'
import Screen from '../components/pages/home/Screen'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import GlobalState, { watchVideo, setLang } from '../stores/GlobalState'
import VideoBox from '../components/VideoBox'
import { observer } from 'mobx-react'
import ContentState, {
  getCoopContent,
  getFooter,
  getHomeContent,
  getMenu,
  getSubMenu,
} from '../stores/ContentState'
import Menu from '../components/Menu'
import LocaleMenu from '../components/LocaleMenu'
import { ReactComponent as Chat } from '../assets/message-square.svg'
import { isMobile } from '../hooks/detect'
import Coop from '../components/common/CoopPop'
import Cookie from '../components/common/Cookie'
import Preloader from '../components/Preloader'
import { useLocation } from 'react-router'
import changeLocaleByPath from '../mocks/changeLocale'

const HomePage = observer(() => {
  const [loading, setLoading] = useState(true)
  const { pathname } = useLocation()
  useEffect(() => {
    changeLocaleByPath(pathname)
    setLang()
    getMenu()
    getSubMenu()
    getFooter()
    getCoopContent()
    getHomeContent().then(() => {})

    return () => {
      setLoading(true)
    }
  }, [])

  useEffect(() => {
    window.addEventListener('orientationchange', function (e) {
      let vh = window.innerHeight * 0.01
      const screens = document.querySelectorAll('.screen:not(.footer)')
      screens.forEach((s) => {
        ;(s as HTMLElement).style.setProperty('--vh', `${vh}px`)
      })
    })
    window.addEventListener('resize', function (e) {
      let vh = window.innerHeight * 0.01
      const screens = document.querySelectorAll('.screen:not(.footer)')
      screens.forEach((s) => {
        ;(s as HTMLElement).style.setProperty('--vh', `${vh}px`)
      })
    })
  }, [])

  useEffect(() => {
    window.addEventListener('mousewheel DOMMouseScroll', function (event: any) {
      if (event.ctrlKey == true) {
        event.preventDefault()
      }
    })
    window.addEventListener('keydown', function (event: any) {
      if (
        event.ctrlKey == true &&
        (event.which == '61' ||
          event.which == '107' ||
          event.which == '173' ||
          event.which == '109' ||
          event.which == '187' ||
          event.which == '189')
      ) {
        event.preventDefault()
      }

      if (
        event.which != '86' &&
        event.which != '67' &&
        event.metaKey &&
        event.which != 65
      ) {
        event.preventDefault()
      }
    })
  }, [])

  useEffect(() => {
    if (!GlobalState.isMenuOpen && !GlobalState.isLocaleOpen) {
      let start = 0

      window.addEventListener('touchstart', (e) => {
        if (!GlobalState.isMenuOpen && !GlobalState.isLocaleOpen) {
          start = e.touches[0].clientY
        }
      })

      window.addEventListener('touchend', (e) => {
        if (!GlobalState.isMenuOpen && !GlobalState.isLocaleOpen) {
          if (
            document.querySelector('.screen.air')?.classList.contains('anim')
          ) {
            if (start + 20 < e.changedTouches[0].clientY) {
              window.location.reload()
            }
          }
        }
      })
    }
  }, [GlobalState.isLocaleOpen, GlobalState.isMenuOpen])

  useEffect(() => {
    if (!ContentState.home) return
    const tops = Array()
    const screens = document.querySelectorAll('.screen')
    screens?.forEach((s) => {
      tops.push({
        screen: s.className.replace('screen', ''),
        top: s.getBoundingClientRect().top,
        bottom: s.getBoundingClientRect().bottom,
      })
    })
    ;(document.querySelector('.container') as any)?.addEventListener(
      'scroll',
      () => {
        let scrollPos = (document.querySelector('.container') as any).scrollTop
        localStorage.setItem('lastPos', scrollPos)
      },
    )
  }, [ContentState.home])

  useEffect(() => {
    if (!ContentState.home) return
    const pos = localStorage.getItem('lastPos')

    if (pos) {
      if (isMobile) {
        ;(document.querySelector('.container') as any).scrollTo(0, +pos + 300, {
          behavior: 'smooth',
        })
        ;(document.querySelector('.container') as HTMLElement).classList.add(
          'scroll-behavior',
        )

        if (!CSS.supports('scroll-snap-type', 'y mandatory')) {
          document.querySelector('#root')!.classList.add('normal-scrolling')
        }

        setTimeout(() => {
          setLoading(false)
        }, 300)
        setTimeout(() => {
          document.querySelector('#root')?.classList.add('visible')
        }, 200)
      } else {
        ;(document.querySelector('.container') as any).scrollTop = +pos
        ;(document.querySelector('.container') as HTMLElement).classList.add(
          'scroll-behavior',
        )

        if (!CSS.supports('scroll-snap-type', 'y mandatory')) {
          document.querySelector('#root')!.classList.add('normal-scrolling')
        }
        setTimeout(() => {
          setLoading(false)
        }, 300)
        setTimeout(() => {
          document.querySelector('#root')?.classList.add('visible')
        }, 200)
      }
    } else {
      setTimeout(() => {
        setLoading(false)
      }, 200)
      document.querySelector('#root')?.classList.add('visible')
    }
  }, [ContentState.home])

  useEffect(() => {
    if (!loading) document.querySelector('#root')?.classList.add('visible')
  }, [loading])

  useEffect(() => {
    let vh = window.innerHeight * 0.01
    const screens = document.querySelectorAll('.screen:not(.footer)')
    screens.forEach((s) => {
      ;(s as HTMLElement).style.setProperty('--vh', `${vh}px`)
    })
    document.querySelector('.header')?.classList.add('home')
  }, [ContentState.home])

  useEffect(() => {
    if (GlobalState.isCoopShow) {
      document.querySelector('body, html, #root')?.classList.add('hidden-menu')
    } else
      document
        .querySelector('body, html, #root')
        ?.classList.remove('hidden-menu')
  }, [GlobalState.isCoopShow])

  return (
    <>
      <Header />
      <Cookie />
      {/* <div className="button chat" id="chat">
        <Chat />
      </div> */}
      {/* <Preloader loading={loading} /> */}

      <div
        className={classNames(
          'container fixed',
          loading && 'hidden',
          !loading && 'visible',
          GlobalState.isLocaleOpen && 'overflow',
          GlobalState.isMenuOpen && 'overflow',
        )}
      >
        <Screen />
      </div>
      <VideoBox
        src={GlobalState.video.src}
        poster={GlobalState.video.poster}
        setShow={() =>
          watchVideo(GlobalState.video.src, GlobalState.video.poster)
        }
      />
      <Menu />
      <LocaleMenu />
      {GlobalState.isCoopShow && <Coop />}
      {/* {GlobalState.isCoopShow && {GlobalState.isCoopShow && <Coop />}} */}
      <div
        className={classNames('menu__bg', GlobalState.isMenuOpen && 'show')}
      ></div>
      <div
        className={classNames('menu__bg', GlobalState.isLocaleOpen && 'show')}
      ></div>
    </>
  )
})

export default HomePage
